import React, { useEffect, useMemo, useState } from 'react';
import FullWidthModal from '../../components/common/Modal/FullWidthModal';
import ModalHeader from '../../components/common/ModalHeader/index';
import cn from 'classnames';
import styles from './viewreceipt.module.scss';
import { TouchableButton } from '../../components/common/Touchable/index';
import { LABEL, CUSTOM_MESSAGES } from '../../veriables';
import Loader from '../../components/common/Loader/newLoaderModal';
import { ReactComponent as LoyaltyCheck } from '@assets/images/loyaltyCheck.svg';
import { connect } from "react-redux";
import { FormatLoyaltyPhoneNumber } from '@utility/helperFunction';
import ModalPopup from '../../components/common/Modal';

const SplitOffersList = props => {
  const { newOfferPopUp, serverAppTheme, seat, handleSplitOffer, handleSplitLyltSubmit, handleSplitCancel, onRedeemRewards, loading, orderingPortraitOrientation,  onNavigateToRedemption } = props;
const [applyOfferConfirm, setApplyOfferConfirm] = useState(null);
  const [selectedLyltChecks, setSelectedLyltChecks] = useState([]);
  const [redeemedSplits, setRedeemedSplits] = useState({});
  const redeemRewardsSeparately = props.auth?.loyaltyInfo?.redeemRewardsSeparately;
  const allowPartialRewardRedemption = props.auth?.loyaltyInfo?.allowPartialRewardRedemption && !redeemRewardsSeparately;
  const checkConsolidateOffer = seat?.control?.displayConsolidatedOffers;
  const seatData = JSON.parse(window.sessionStorage.getItem('seat'));
  const popUpModal = useMemo(() => {
    const okButton = {
      backgroundColor: serverAppTheme?.secondaryBtn,
      color: '#ffff',
      border: 'none',
      borderRadius: '8px',
    };

    return { okButton };
  }, [serverAppTheme]);

  const handleSeatNumber = (data, isAppliedOffers) => {
    let seats = [];
    if (seatData?.paymentCheck?.splitType === 0) {
      seats = seatData?.paymentCheck?.seats || [];
    } else {
      const checks = seat?.paymentChecks || [];
      const offersMap = seat?.availableLoyaltyOffers || {};

      let selectedLoyalty;

      if (data) {
        selectedLoyalty = checks.find(
          (e) => Number(e?.checkSplitId) === Number(data)
        );
      } else if (isAppliedOffers) {
        const firstKey = Object.keys(offersMap)[0];

        if (!!firstKey) {
          selectedLoyalty = checks.find(
            (e) => Number(e?.checkSplitId) === Number(firstKey)
          );
        }
      }
      seats = selectedLoyalty?.seats || [];
    }

    const sortedSeats = seats?.sort((a, b) => {
      const numA = (a?.number !== null && a?.number !== undefined) ? Number(a?.number) : Infinity;
      const numB = (b?.number !== null && b?.number !== undefined) ? Number(b?.number) : Infinity;
      return numA - numB;
    });

    return sortedSeats.map(e => e?.number?.toString() ?? '').filter(Boolean).join(',');
  };

  // This logic from loyalty object
  const getSeatNumber = (checkId, seatId) => {
    let seatNum;
    if (seatData?.paymentCheck?.splitType === 0) {
      const fullCheckSelectedLylt = seat?.paymentCheck?.seats?.find(e => e?.id === seatId);
      seatNum = fullCheckSelectedLylt?.number;
    } else {
      const selectedSeat = seat?.paymentChecks?.find(e => Number(e.checkSplitId) === Number(checkId));
      const selectedSeatLoyalty = selectedSeat?.seats?.find(e => e?.id === seatId)
      seatNum = selectedSeatLoyalty?.number;
    }
    return seatNum;
  };

  const getLoyaltyNameAccount = (checkId, lytId) => {
    const findSeat = seat?.paymentChecks?.find(e => Number(e.checkSplitId) === Number(checkId));
    return findSeat?.loyalties?.find(e => e?.id === lytId);
  };

  const handleDisplayCheckNumber = (data, isAppliedOffers) => {
  if (seatData?.paymentCheck?.splitType === 0) {
    return seatData?.paymentCheck?.splitNumber;
  }

  const checks = seat?.paymentChecks || [];
  const offersMap = seat?.availableLoyaltyOffers || {};

  let selectedSplit;

  if (data) {
    selectedSplit = checks.find(
      (e) => Number(e.checkSplitId) === Number(data)
    );
  } else if (isAppliedOffers) {
    const firstKey = Object.keys(offersMap)[0];

    if (firstKey) {
      selectedSplit = checks.find(
        (e) => Number(e.checkSplitId) === Number(firstKey)
      );
    }
  }

  return selectedSplit?.splitNumber || '';
};


  useEffect(() => {
    if (seat?.availableLoyaltyOffers && (seat?.paymentChecks || seat?.paymentCheck) && !seat?.control?.displayConsolidatedOffers) {
      const hashKeys = Object.keys(seat.availableLoyaltyOffers);
      const checks = seat?.paymentChecks ?? (seat?.paymentCheck ? [seat.paymentCheck] : []);
      const filteredLyltChecks = checks.filter(
        (item) => !hashKeys.includes(item.checkSplitId)
      );
      setSelectedLyltChecks(filteredLyltChecks);
    } else {
      setSelectedLyltChecks([]);
    }
  }, [seat?.availableLoyaltyOffers, seat?.paymentChecks, seat?.paymentCheck, seat?.control?.displayConsolidatedOffers]);

  const filteredRewards = useMemo(() => {
    return Object.values(seat?.availableLoyaltyOffers || {})
      .flat()
      .flatMap(loyalty => loyalty?.offers || [])
      .filter(offer => offer?.offerCategory === 1);

  }, [
    seat?.availableLoyaltyOffers
  ]);

  const splitLoyaltySubmit = (offer, accountItem, accountId) => {
    let getSplitId;
    if (seat?.splitType === 0) {
      getSplitId = seat?.paymentCheck;
    } else {
      getSplitId = seat?.paymentChecks?.find(e => Number(e.checkSplitId) === Number(accountId));
    }
    handleSplitOffer(offer, accountItem, getSplitId?.checkSplitId);
  };
  const openApplyOfferConfirm = (offer, accountItem, accountId) => {
    setApplyOfferConfirm({ offer, accountItem, accountId });
  };

  const getRewardsTextFromAccounts = (accounts = []) => {
    const rewards = accounts
      .flatMap(acc => acc?.offers || [])
      .filter(o => o?.offerCategory === 1)
      .map(o => `$${Number(o?.value)?.toFixed(2)}`)
      .join(', ');

    return rewards || 'None';
  };

  const getRewardsFromAvailableOffers = (checkSplitId) => {
    let accounts;

    if (checkSplitId) {
      accounts = seat?.availableLoyaltyOffers?.[checkSplitId];
    } else {
      accounts = Object.values(seat?.availableLoyaltyOffers || {})[0];
    }

    const rewards = (accounts ?? [])
      .flatMap((acc) => acc?.offers || [])
      .filter((o) => o?.offerCategory === 1)
      .map((o) => {
        const val = Number(o?.value);
        return isNaN(val) ? '' : `$${val.toFixed(2)}`;
      })
      .filter(Boolean)
      .join(', ');

    return rewards || 'None';
  };

  const getOffersList = (accountId) => {
    const accounts = seat?.availableLoyaltyOffers?.[accountId];

    return Array.isArray(accounts) &&
      accounts.some(acc =>
        acc?.offers?.some(o => o?.offerCategory === 0)
      );
  };

  const splitRewardSubmit = (offer, accountItem, accountId) => {
    let getSplitId;
    if (seat?.splitType === 0) {
      getSplitId = seat?.paymentCheck;
    } else {
      getSplitId = seat?.paymentChecks?.find(e => Number(e.checkSplitId) === Number(accountId));
    }
    const splitId = getSplitId?.checkSplitId;

    if (allowPartialRewardRedemption) {
      onNavigateToRedemption(offer, accountItem, splitId);
      setRedeemedSplits(prev => ({ ...prev, [accountId]: true }));
    } else {
      handleRedeemReward(offer, accountItem, splitId);
    }
  };
   const handleConfirmApplyOffer = () => {
    if (applyOfferConfirm) {
      const { offer, accountItem, accountId } = applyOfferConfirm;
      splitLoyaltySubmit(offer, accountItem, accountId);
    }
    setApplyOfferConfirm(null);
  };
  const handleCancelApplyOffer = () => {
    setApplyOfferConfirm(null);
  };

  return (
    <FullWidthModal
      isOpen={newOfferPopUp}
      customClass2={cn('w-100 h-100 position-relative')}
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        pointerEvents: 'auto',
        backgroundColor: serverAppTheme?.popUp_bg,
        backgroundClip: 'padding-box',
        border: '0',
        boxShadow: serverAppTheme?.popUp_box_shadow,
      }}
    >
      {loading && <Loader />}
      <div
        className="col-12 px-0 justify-content-center align-items-center position-relative text-center h-100"
        style={popUpModal.primaryTextColor}
      >
        <div
          className={cn(
            'col-12 px-0 fs_18 align-items-center justify-content-center fw-600 h-100'
          )}
        >
          <ModalHeader
            stationName={seat?.stationName}
            tileHeader={LABEL().LS_AVAILABLE_OFFERS}
            seatNumber={seat?.number}
          />
          <div className={cn('px-2 pt-2 d-flex text-left align-items-center fw-normal mx-2', orderingPortraitOrientation ? 'fs_12' : 'fs_14')} style={{
            fontFamily: 'Poppins',
            color: serverAppTheme?.secondary_text,
          }}>
            <div className={cn('col-3 mx-0', orderingPortraitOrientation ? 'pl-2 pr-0' : 'px-0')}>Offer</div>
            <div className='col-1 px-0 mx-0'>Value</div>
            <div className={cn('col-1 mx-0', orderingPortraitOrientation ? 'pl-2 pr-0' : 'px-0')}>Seat</div>
            <div className={cn('col-3 mx-0', orderingPortraitOrientation ? 'pl-2 pr-0' : 'px-0' )}>Guest Name</div>
            <div className='col-2 px-0 mx-0'>Account Number</div>
            <div className='col-2 px-0 mx-0'></div>
          </div>
          <div className={cn('overflowY', orderingPortraitOrientation ? 'h-80 pt-2' : 'h-75')}>
            {!(checkConsolidateOffer && seat?.check?.offers?.length > 0) && Object.entries(seat?.availableLoyaltyOffers).map(([accountId, account], checkIndex) => (
              <div key={accountId} className={cn( orderingPortraitOrientation ? 'px-3' : 'px-2', (seatData?.paymentCheck ? seatData?.paymentCheck?.splitType === 0 : seatData?.paymentChecks[0]?.splitType === 3) ? "pt-2" : "pt-0")}>
                  {getOffersList(accountId) && <div className="col-12 px-0 py-2">
                    <div className={cn('col-12 fs_12 fw-400 d-flex justify-content-between rounded align-items-center py-2')} style={{ background: serverAppTheme?.checkDetail_tabs }}>
                      <div className={cn(redeemRewardsSeparately ? 'col-3' : 'col-6', 'text-left p-0')}>
                        Check {handleDisplayCheckNumber(accountId)}
                      </div>
                      {redeemRewardsSeparately && <div className='col-6 fw-500 text-center p-0'>
                        {LABEL().LS_REWARDS}: {getRewardsTextFromAccounts(account)}
                      </div>}
                      <div className={cn(redeemRewardsSeparately ? 'col-3' : 'col-6', 'text-right pr-0', styles.scrollableText)}>
                        Seat {handleSeatNumber(accountId)}
                      </div>
                    </div>
                  </div>}
                {Array.isArray(account) && account.length > 0 ? (
                  account.map((accountItem) => (
                    accountItem.offers && accountItem.offers.length > 0 ? (
                      accountItem.offers.map((offer, offerIndex) => {
                        return (
                          <div>
                            {(!redeemRewardsSeparately || offer?.offerCategory === 0) &&
                            <div className={cn(styles.offerTile, 'p-2 d-flex text-left align-items-center fw-normal mb-2 rounded', orderingPortraitOrientation ? 'fs_12' : 'fs-16')} style={{ background: serverAppTheme?.checkDetail_tabs, border: serverAppTheme?.select_border }}>
                              <div className='col-3 px-0 mx-0'>{offer.name}</div>
                              <div className='col-1 px-0 mx-0'>{LABEL().CURRENCY_SYMBOL}{offer.value.toFixed(2)}</div>
                              <div className={cn('col-1 px-0 mx-0', orderingPortraitOrientation ? 'd-flex justify-content-center' : '')}>
                                <div
                                  className='fw-500 color-black  roundedSm d-flex justify-content-center align-items-center'
                                  style={{
                                    width: '1.8rem',
                                    height: '1.25rem',
                                    background: serverAppTheme?.seat_bg,
                                    color: serverAppTheme?.seat_box_text,
                                  }}
                                >
                                  {getSeatNumber(accountId, accountItem.seatId)}
                                </div>
                              </div>
                              <div className='col-3 px-0 mx-0'>{accountItem?.guestName}</div>
                              <div className='col-2 px-0 mx-0'>{FormatLoyaltyPhoneNumber(accountItem?.displayAccountNumber)}</div>
                              <div className='col-2 px-0 mx-0'>
                                {allowPartialRewardRedemption && offer?.offerCategory === 1 ?
                              <TouchableButton
                                type="button"
                                className={cn(
                                  styles.loyalty_btn,
                                  'col-12 px-0 btn btn-ripple od-primary-btn-bg-color od-primary-btn-font-color',
                                  orderingPortraitOrientation
                                    ? styles.applyBtnFont
                                    : ''
                                )}
                                onClick={event => {
                                  event.preventDefault();
                                  splitRewardSubmit(
                                    offer,
                                    accountItem,
                                    accountId
                                  );
                                }}
                                style={{
                                  height: orderingPortraitOrientation
                                    ? '24px'
                                    : '7.5vh',
                                }}
                                rippleEffect={true}
                              >
                                {LABEL().LS_REDEEM}
                              </TouchableButton>
                              :
                                <TouchableButton
                                  type="button"
                                  className={cn(styles.loyalty_btn, "col-12 px-0 btn btn-ripple od-primary-btn-bg-color od-primary-btn-font-color", orderingPortraitOrientation ? styles.applyBtnFont : '')}
                                  onClick={(event) => {
                                    event.preventDefault();
                                    openApplyOfferConfirm(offer, accountItem, accountId);
                                    // splitLoyaltySubmit(offer, accountItem, accountId)
                                  }}
                                  style={{ height: orderingPortraitOrientation ? '24px' : "7.5vh" }}
                                  rippleEffect={true}
                                >
                                  {LABEL().LS_APPLY_OFFERS}
                                </TouchableButton>}
                              </div>
                            </div>}
                          </div>
                        )
                      })
                    ) : (<>No Offers in this account</>)
                  ))
                ) : (<>No Offers</>)}
              </div>
            ))}
            {/* {checkConsolidateOffer ? ( */}
              <div className={cn('pt-2', orderingPortraitOrientation ? 'px-3' : 'px-2')}>
                {checkConsolidateOffer && seat?.check?.offers?.length > 0 && seat?.check?.offers?.map((offer) => {
                  const loyalty = offer?.checkLoyaltyId
                      ? seat?.check?.loyalties?.find(e => e?.id === offer?.checkLoyaltyId)
                      : null;
                  return (
                    <div key={offer?.checkLoyaltyId}>
                      {(!redeemRewardsSeparately || offer?.offerCategory === 0) && <div className="col-12 px-0 py-2">
                        <div className={cn('col-12 fs_12 fw-400 d-flex justify-content-between rounded align-items-center py-2')} style={{ background: serverAppTheme?.checkDetail_tabs }}>
                          <div className={cn(redeemRewardsSeparately? 'col-3': 'col-6', 'text-left p-0')}>
                            Check {handleDisplayCheckNumber(offer?.checkSplitId, true)}
                          </div>
                          {redeemRewardsSeparately && <div className='col-6 fw-500 text-center p-0'>
                            {LABEL().LS_REWARDS}: {getRewardsFromAvailableOffers(offer?.checkSplitId)}
                          </div>}
                          <div className={cn(redeemRewardsSeparately? 'col-3': 'col-6', 'text-right pr-0', styles.scrollableText)}>
                            Seat {handleSeatNumber(offer?.checkSplitId, true)}
                          </div>
                        </div>
                      </div>}
                      {(!redeemRewardsSeparately || offer?.offerCategory === 0) &&
                      <div className={cn(styles.offerTile, 'p-2 d-flex text-left align-items-center fw-normal mb-2 rounded', orderingPortraitOrientation ? 'fs_12' : 'fs-16')} style={{ background: serverAppTheme?.checkDetail_tabs, border: serverAppTheme?.select_border }}>
                        <div className='col-3 px-0 mx-0'>{offer.name}</div>
                        <div className='col-1 px-0 mx-0'>{LABEL().CURRENCY_SYMBOL}{(offer?.amount ?? 0)?.toFixed(2)}</div>
                        <div className={cn('col-1 px-0 mx-0', orderingPortraitOrientation ? 'd-flex justify-content-center' : '')}>
                          <div
                            className='fw-500 color-black  roundedSm d-flex justify-content-center align-items-center'
                            style={{
                              width: '1.8rem',
                              height: '1.25rem',
                              background: serverAppTheme?.seat_bg,
                              color: serverAppTheme?.seat_box_text,
                            }}
                          >
                            {checkConsolidateOffer && seat?.paymentChecks?.length > 0 ? seat?.paymentChecks[0]?.seats?.find(e => e?.id === offer?.seatId)?.number : seat?.paymentCheck?.seats?.find(e => e?.id === offer?.seatId)?.number}
                          </div>
                        </div>
                        <div className='col-3 px-0 mx-0'>
                          {loyalty?.guestName || ""}
                        </div>
                        <div className='col-2 px-0 mx-0'>
                          {loyalty?.displayAccountNumber
                              ? FormatLoyaltyPhoneNumber(loyalty.displayAccountNumber)
                              : ""}                          
                        </div>
                        <div className='col-2 px-0 mx-0 d-flex justify-content-center'>
                          <LoyaltyCheck />
                        </div>
                      </div>}
                    </div>
                  )
                })}
              </div>
            {/* ) : ( */}
              <div className={cn('pt-2', orderingPortraitOrientation ? 'px-3' : 'px-2')}>
                {!checkConsolidateOffer && selectedLyltChecks?.length > 0 && selectedLyltChecks.map((lyltCheck) => (
                  <div key={lyltCheck.checkSplitId}>
                    {lyltCheck?.offers?.some(o => !redeemRewardsSeparately || o?.offerCategory === 0) && (
                      <div className="col-12 px-0 py-2">
                        <div className={cn('col-12 fs_12 fw-400 d-flex justify-content-between rounded align-items-center py-2')} style={{ background: serverAppTheme?.checkDetail_tabs }}>
                          <div className={cn(redeemRewardsSeparately? 'col-3': 'col-6', 'text-left p-0')}>
                            Check {handleDisplayCheckNumber(lyltCheck.checkSplitId)}
                          </div>
                          {redeemRewardsSeparately && <div className='col-6 fw-500 text-center p-0'>
                            {LABEL().LS_REWARDS}: {getRewardsFromAvailableOffers(lyltCheck?.checkSplitId)}
                          </div>}
                          <div className={cn(redeemRewardsSeparately? 'col-3': 'col-6', 'text-right pr-0', styles.scrollableText)}>
                            Seat {handleSeatNumber(lyltCheck.checkSplitId)}
                          </div>
                        </div>
                      </div>
                    )}
                    {lyltCheck.offers && lyltCheck.offers.length > 0 && lyltCheck.offers.map((offer) => {
                      const loyalty = offer?.checkLoyaltyId
                          ? getLoyaltyNameAccount(lyltCheck.checkSplitId, offer?.checkLoyaltyId)
                          : null;
                      return (
                      <div>
                      {(!redeemRewardsSeparately || offer?.offerCategory === 0) &&
                      <div key={offer.id} className={cn(styles.offerTile, 'p-2 d-flex text-left align-items-center fw-normal mb-2 rounded', orderingPortraitOrientation ? 'fs_12' : 'fs-16')} style={{ background: serverAppTheme?.checkDetail_tabs, border: serverAppTheme?.select_border }}>
                        <div className='col-3 px-0 mx-0'>{offer.name}</div>
                        <div className='col-1 px-0 mx-0'>{LABEL().CURRENCY_SYMBOL}{offer.value.toFixed(2)}</div>
                        <div className={cn('col-1 px-0 mx-0', orderingPortraitOrientation ? 'd-flex justify-content-center' : '')}>
                          <div
                            className='fw-500 color-black  roundedSm d-flex justify-content-center align-items-center'
                            style={{
                              width: '1.8rem',
                              height: '1.25rem',
                              background: serverAppTheme?.seat_bg,
                              color: serverAppTheme?.seat_box_text,
                            }}
                          >
                            {getSeatNumber(lyltCheck.checkSplitId, offer.seatId)}
                          </div>
                        </div>
                        <div className='col-3 px-0 mx-0'>{loyalty?.guestName}</div>
                        <div className='col-2 px-0 mx-0'>{loyalty?.displayAccountNumber
                                  ? FormatLoyaltyPhoneNumber(loyalty.displayAccountNumber)
                                  : ""}</div>
                        <div className='col-2 px-0 mx-0 d-flex justify-content-center'>
                          <LoyaltyCheck />
                        </div>
                      </div>
                      }
                      </div>
                    )})}
                  </div>
                ))}
              </div>
            {/* )} */}
          </div>
          <div className={cn('h-20 color-white pt-12 d-flex justify-content-center', orderingPortraitOrientation ? 'col-12 px-3' : '')}>
            <div className={cn("pl-0 pr-0 d-flex mb-1 mr-2", orderingPortraitOrientation ? 'col-6' : 'col-4')}>
              <TouchableButton
                type="button"
                className={cn("col-12 px-0 d-flex justify-content-center align-items-center od-cancel-btn-bg-color od-cancel-btn-font-color od-cancel-btn-st-color", styles.loyalty_btn)}
                onClick={(event) => {
                  event.preventDefault();
                  handleSplitCancel();
                }}
                style={{ height: "7.5vh", backgroundColor: serverAppTheme?.OFF_Premise_Btn, color: serverAppTheme?.primary_text, border: "1px solid #2541A4" }}
                rippleEffect={true}
              >
                <div className={cn("fw-600", orderingPortraitOrientation ? 'fs_28' : 'fs_24')}>{LABEL().LS_BACK_TO_CHECK}</div>
              </TouchableButton>
            </div>
            {redeemRewardsSeparately && filteredRewards?.length > 0 ?
            <div className={cn("pl-0 pr-0 d-flex mb-1 justify-content-start", orderingPortraitOrientation ? 'col-6' : 'col-4')}>
              <TouchableButton
                type="button"
                className={cn(
                  'col-12 px-0 btn-ripple d-flex justify-content-center align-items-center od-primary-btn-bg-color od-primary-btn-font-color ',
                  styles.loyalty_btn
                )}
                style={{ height: '7.5vh' }}
                onClick={(event) => {
                  event.preventDefault();
                  onRedeemRewards();
                }}
                rippleEffect={true}
              >
                <div className={cn("fw-600", orderingPortraitOrientation ? 'fs_28' : 'fs_24')}>{LABEL().LSO_CONTINUE}</div>
              </TouchableButton>
            </div>
            :
            <div className={cn("pl-0 pr-0 d-flex mb-1 justify-content-start", orderingPortraitOrientation ? 'col-6' : 'col-4')}>
              <TouchableButton
                type="button"
                className={cn(
                  'col-12 px-0 btn-ripple d-flex justify-content-center align-items-center od-primary-btn-bg-color od-primary-btn-font-color ',
                  styles.loyalty_btn
                )}
                style={{ height: '7.5vh' }}
                onClick={(event) => {
                  event.preventDefault();
                  handleSplitLyltSubmit(seatData?.paymentCheck?.splitType);
                }}
                rippleEffect={true}
              >
                <div className={cn("fw-600", orderingPortraitOrientation ? 'fs_28' : 'fs_24')}>{LABEL().LS_DONE}</div>
              </TouchableButton>
            </div>}
          </div>
        </div>
      </div>
      {applyOfferConfirm && (
        <ModalPopup
          isOpen={!!applyOfferConfirm}
          isModalCenter
          style={{
            backgroundColor: serverAppTheme?.popUp_bg,
            borderRadius: '16px',
            border: serverAppTheme?.popupBorder,
            boxShadow: serverAppTheme?.popUp_box_shadow,
            width: '75%',
            margin: 'auto',
            minHeight: '42%',
            height: 'auto',
            padding: '1.5rem',
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
          }}
          noBackground
          customClass='h-100 w-100'
          customClass2='h-100 w-100 p-3'
        >
          <div style={{ flex: 1, color: serverAppTheme?.primary_text }} className="justify-content-center align-items-center text-center h-100 position-relative">
            {/* <div className='col-12 fs_18 fw-700 text-center h-auto'>Are You Sure?</div><br /> */}
            <div className="col-12 pt-4 px-0 fs_15 fw-400 text-center">
              {CUSTOM_MESSAGES().LS_THIS_WILL_APPLY_THE_OFFER} <span className='fw-600'>{applyOfferConfirm?.offer?.name}</span>.{CUSTOM_MESSAGES().LS_DO_YOU_WANT_TO_CONTINUE}
            </div>
            <div style={{ bottom: '0', left: '0' }} className="col-12 px-0 h-30 d-flex justify-content-center align-items-center text-center position-absolute">
              <div className='col-6 pl-0 pr-1'>
                <TouchableButton
                  style={{ background: serverAppTheme?.OFF_Premise_Btn, color: serverAppTheme?.cancleBtn_font, border: serverAppTheme?.cancleBtn_Border }}
                  className={cn("col-12 fs_24 fw-600 btn-44 rounded btn44 od-cancel-btn-bg-color od-cancel-btn-font-color od-cancel-btn-st-color")}
                  type="button"
                  onClick={handleCancelApplyOffer}
                  rippleEffect={true}
                >
                  {LABEL().LS_NO}
                </TouchableButton>
              </div>
              <div className='col-6 pl-1 pr-0'>
                <TouchableButton
                  style={{ background: serverAppTheme?.secondaryBtn, color: serverAppTheme?.btn_font_color }}
                  className={cn("col-12 btn-ripple fs_24 fw-600 border-0 rounded btn44 od-primary-btn-bg-color od-primary-btn-font-color")}
                  type="button"
                  onClick={handleConfirmApplyOffer}
                  rippleEffect={true}
                >
                  {LABEL().LS_YES}
                </TouchableButton>
              </div>
            </div>
          </div>
        </ModalPopup>
      )}
    </FullWidthModal>
  )
};
const mapStateToProps = ({ orders }) => ({
  orderingPortraitOrientation: orders.orderingPortraitOrientation
});
export default connect(mapStateToProps)(SplitOffersList);
